import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\UpdateInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/UpdateInvoiceController.php
* @route '/api/invoicing/{invoice}'
*/
const UpdateInvoiceController = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoiceController.url(args, options),
    method: 'put',
})

UpdateInvoiceController.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Invoice\UpdateInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/UpdateInvoiceController.php
* @route '/api/invoicing/{invoice}'
*/
UpdateInvoiceController.url = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { invoice: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { invoice: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
    }

    return UpdateInvoiceController.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\UpdateInvoiceController::__invoke
* @see app/Http/Controllers/Invoice/UpdateInvoiceController.php
* @route '/api/invoicing/{invoice}'
*/
UpdateInvoiceController.put = (args: { invoice: string | number | { id: string | number } } | [invoice: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateInvoiceController.url(args, options),
    method: 'put',
})

export default UpdateInvoiceController